import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';

export default function createTheme(options) {
  let theme = createMuiTheme(options);
  theme = responsiveFontSizes(theme);

  return theme;
}
